import * as React from "react";

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Skeleton from '@mui/material/Skeleton';
import { styled } from '@mui/system';


const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: '#102a43',
    color: '#ffffff',
    borderBottom: 'none',
    fontSize: 12,
    fontWeight: 800,
    letterSpacing: '0.06em',
    textTransform: 'uppercase',
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    color: '#20334a',
    borderColor: '#e5edf4',
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: '#f8fbfd',
  },
  '&:nth-of-type(even)': {
    backgroundColor: '#ffffff',
  },
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}));

export default function StandingsTable({teams, loading, year, standingsType}) {
  const showFinal = standingsType === 'final' && year !== new Date().getFullYear()
  const showRegular = standingsType === 'regular'

  const show = showRegular || showFinal
  return (
    <TableContainer sx={{ border: '1px solid #dce5ee', borderRadius: 2, overflowX: 'auto' }}>
      <Table sx={{ minWidth: 650 }} size="small">
        <TableHead>
          <TableRow>
            <StyledTableCell>Rank</StyledTableCell>
            <StyledTableCell align="left">Team</StyledTableCell>
            <StyledTableCell align="left">Record</StyledTableCell>
            <StyledTableCell align="left">PF</StyledTableCell>
            <StyledTableCell align="left" >PA</StyledTableCell>
            {year === new Date().getFullYear() && <StyledTableCell align="left" >Streak</StyledTableCell>}
            {year > 2020 && <StyledTableCell align="left">Draft Day Rank</StyledTableCell>}


          </TableRow>
        </TableHead>
        <TableBody>
          {
            loading &&

            Array(12).fill(0).map((_, i) => 
            <StyledTableRow
            key={i}
            sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
          >
            <StyledTableCell align="left"><Skeleton animation="wave" variant="rectangular"  /></StyledTableCell>
            <StyledTableCell align="left"><Skeleton animation="wave" variant="rectangular"  /></StyledTableCell>
            <StyledTableCell align="left"><Skeleton animation="wave" variant="rectangular"  /></StyledTableCell>
            <StyledTableCell align="left"><Skeleton animation="wave" variant="rectangular"  /></StyledTableCell>
            <StyledTableCell align="left" ><Skeleton animation="wave" variant="rectangular"  /></StyledTableCell>
            {year === new Date().getFullYear() && <StyledTableCell align="left"><Skeleton animation="wave" variant="rectangular"  /></StyledTableCell>}
            {year > 2020 && <StyledTableCell align="left"><Skeleton animation="wave" variant="rectangular"  /></StyledTableCell>}


          </StyledTableRow>
            
            )
            
          }

          {!loading && teams && show && teams.map((team, i) => {
            const record = getRecord(team)
            const streak = getStreak(team)
            return (<StyledTableRow
              key={i}
              sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
            >
              <StyledTableCell component="th" scope="row">
                {i + 1}
              </StyledTableCell>
              <StyledTableCell align="left">{team.name}</StyledTableCell>
              <StyledTableCell align="left">{record}</StyledTableCell>
              <StyledTableCell align="left">{team.Record.Overall.pointsFor}</StyledTableCell>
              <StyledTableCell align="left" >{team.Record.Overall.pointsAgainst}</StyledTableCell>
              {year === new Date().getFullYear() && <StyledTableCell align="left">{streak}</StyledTableCell>}
              {year > 2020 && <StyledTableCell align="left">{team.draftDayProjectedRank}</StyledTableCell>}


            </StyledTableRow>

            )})}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

function getRecord(team) {
   if (team.Record.Overall.ties > 0) {
    return team.Record.Overall.wins + "-" + team.Record.Overall.losses + "-" + team.Record.Overall.ties 
   } else {
    return team.Record.Overall.wins + "-" + team.Record.Overall.losses
   }
}

function getStreak(team) {
    if (team.Record.Overall.streakType == 'WIN') {
        return 'W' + team.Record.Overall.streakLength
    } else {
        return 'L' + team.Record.Overall.streakLength
    }
}
